import { useCallback, useEffect, useState } from 'react';
import { shouldDisableBrowserClose } from 'App/ProgressAlert/utils';
import { ResourceLaunchProgressMap } from 'Workspace/ResourceProvider/Context';

export const usePreventBrowserClose = (launchProgress: ResourceLaunchProgressMap) => {
	const [showWait, setShowWait] = useState(false);

	const avoidBrowserClose = useCallback((event: Event) => {
		setShowWait(true);
		event.preventDefault();
		event.returnValue = true;
		return false;
	}, []);

	useEffect(() => {
		const disableBrowserClose = shouldDisableBrowserClose(launchProgress);

		if (!disableBrowserClose) {
			setShowWait(false);
		}

		if (disableBrowserClose) {
			window.addEventListener('beforeunload', avoidBrowserClose);
		}

		return () => {
			if (disableBrowserClose) {
				window.removeEventListener('beforeunload', avoidBrowserClose);
			}
		};
	}, [launchProgress, avoidBrowserClose]);

	return { showWait, setShowWait };
};
